import { ActionInfoModel, LocalizedValueModel, RefProperty } from '../models';

export class UserModel {
  id: string;
  specificationVersion?: number;
  creationInfo?: ActionInfoModel;
  updateInfo?: ActionInfoModel;
  accountInfo: {
    userName: string;
    emailAddress: string;
  };
  basicInfo: {
    firstName: LocalizedValueModel;
    fullName: LocalizedValueModel;
    lastName: LocalizedValueModel;
    phoneNumber: string;
    birthDate: Date;
    profilePicture: string;
    gender: string;
  };
  workInfo: {
    orgUnit: RefProperty;
  };

  // @TODO: The following props should be removed later and keep only the mapped props
  dataEntity: string;
  state: any;
  value: {
    [key: string]: RefProperty | any;
  };
}
